export default "__VITE_ASSET__vQRipiQ8__"